import { useState } from 'react';
import NavItem from 'components/app/topbar/navigation/NavItem';
import DropdownMenu from 'react-dd-menu';
import { MenuItem } from 'components/menu/MenuItems';
import { RouteUrls } from 'routes/RouteConstants';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasCapitalTrackerEnabled } from 'state/user/selectors';
import { AppFeaturePermissions, usePermissions } from 'contexts';

const menuItemStyle = { width: '180px' };

const PlanningMenu = ({
    isHoldSell,
    isCapitalTracker,
    capitalTrackerEnabled,
    isPrioritiesAndObjectives,
    isServiceContracts,
}) => {
    const { featurePermissions } = usePermissions();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const activeState =
        isHoldSell || isCapitalTracker || isPrioritiesAndObjectives;

    const showCapitalProjects = featurePermissions?.includes(
        AppFeaturePermissions.CapitalProjects
    );
    const showPrioritiesAndObjectives = featurePermissions?.includes(
        AppFeaturePermissions.PrioritiesAndObjectives
    );
    const showServiceContracts = featurePermissions?.includes(
        AppFeaturePermissions.Contracts
    );
    const showHoldSell = featurePermissions?.includes(
        AppFeaturePermissions.HoldSell
    );

    const renderButton = () => {
        return (
            <NavItem
                title={'Planning'}
                active={activeState}
                icon=""
                onClick={toggleMenu}
                hideTooltip={true}
                dropdown
                style={{ paddingLeft: '23px' }}
            >
                <i
                    className="fa-solid fa-tasks"
                    size="lg"
                    style={{
                        position: 'absolute',
                        left: '5px',
                    }}
                />
                <i
                    className="fa-solid fa-caret-down"
                    size="lg"
                    style={{
                        paddingLeft: '6px',
                        fontSize: '16px',
                    }}
                />
            </NavItem>
        );
    };

    if (
        !showCapitalProjects &&
        !showPrioritiesAndObjectives &&
        !showServiceContracts &&
        !showHoldSell
    ) {
        return null;
    }

    return (
        <DropdownMenu
            animate={false}
            align="left"
            isOpen={isMenuOpen}
            toggle={renderButton()}
            close={toggleMenu}
        >
            {capitalTrackerEnabled && showCapitalProjects && (
                <MenuItem
                    active={isCapitalTracker}
                    style={menuItemStyle}
                    to={RouteUrls.PLANNING_CAPITAL_TRACKER}
                >
                    <span>Capital Projects</span>
                </MenuItem>
            )}
            {showPrioritiesAndObjectives && (
                <MenuItem
                    active={isPrioritiesAndObjectives}
                    style={menuItemStyle}
                    to={RouteUrls.PLANNING_PRIORITIES_AND_OBJECTIVES}
                >
                    <span>Priorities & Objectives</span>
                </MenuItem>
            )}

            {showServiceContracts && (
                <MenuItem
                    active={isServiceContracts}
                    style={menuItemStyle}
                    to={RouteUrls.PLANNING_SERVICE_CONTRACTS}
                >
                    <span>Service Contracts</span>
                </MenuItem>
            )}
            {showHoldSell && (
                <MenuItem
                    active={isHoldSell}
                    style={menuItemStyle}
                    to={RouteUrls.PLANNING_HOLD_SELL}
                >
                    <span>Hold/Sell</span>
                </MenuItem>
            )}
        </DropdownMenu>
    );
};

export default withRouter(
    connect((state) => {
        const {
            browser: { mediaType },
        } = state;

        const {
            routing: {
                locationBeforeTransitions: { pathname },
            },
        } = state;

        const isHoldSell = pathname.includes(RouteUrls.PLANNING_HOLD_SELL);
        const isCapitalTracker = pathname.includes(
            RouteUrls.PLANNING_CAPITAL_TRACKER
        );
        const isPrioritiesAndObjectives = pathname.includes(
            RouteUrls.PLANNING_PRIORITIES_AND_OBJECTIVES
        );
        const isServiceContracts = pathname.includes(
            RouteUrls.PLANNING_SERVICE_CONTRACTS
        );

        return {
            isLarge: mediaType === 'lg',
            isHoldSell,
            isCapitalTracker,
            isPrioritiesAndObjectives,
            isServiceContracts,
            capitalTrackerEnabled: hasCapitalTrackerEnabled(state),
        };
    })(PlanningMenu)
);
